import { Button, useTheme } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

type PostEditConfirmModalProps = {
  open: boolean
  onClose: () => void
  onClick: () => void
  loading: boolean
}
export const PostEditConfirmModal = ({
  open,
  onClose,
  onClick,
  loading,
}: PostEditConfirmModalProps) => {
  const { t } = useTranslation('consolePostEdit')
  const { zIndex } = useTheme()

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('confirmEditTitle')}
      content={null}
      buttons={
        <Button
          size="large"
          sx={{ width: 212 }}
          onClick={onClick}
          loading={loading}
          disabled={loading}
        >
          {t('toUpdate')}
        </Button>
      }
      cancelText={t('cancel')}
      sx={{
        zIndex: zIndex.modal + 2,
      }}
    />
  )
}
